import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import { RandomVideoChatBanner, SROnlyH1 } from "./Banners";
import FAQSection from "../../components/FAQSection";
import "./landing.css";

export default function RandomVideoChat() {
  return (
    <>
      <SEO
        title="Random Video Chat - Talkvee"
        description="Meet new people instantly with Talkvee’s random video chat. Match by interests, play quick trivia battles, and share VeeClips."
        pathname="/random-video-chat"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://talkvee.com" },
            { "@type": "ListItem", "position": 2, "name": "Random Video Chat", "item": "https://talkvee.com/random-video-chat" }
          ]
        }}
      />

      <div className="landing-wrapper">
        <RandomVideoChatBanner />
        <section className="landing-hero">
          <h1 className="landing-title">Random Video Chat — Meet New People Fast</h1>
          <p className="landing-subtitle">
            One click to connect. Use interests for better matches, enjoy fast icebreakers,
            and share your moments in VeeClips to share highlights with consent.
          </p>
          <Link to="/" className="tv-cta">🚀 Start Chatting on Talkvee</Link>
        </section>

        <FAQSection
          items={[
            {
              q: "What makes Talkvee’s random video chat different?",
              a: "Unlike other platforms, Talkvee is ad-free, built for safety, and comes with fun extras like trivia challenges to break the ice."
            },
            {
              q: "How does random video chat work?",
              a: "Click 'Start Chatting' and we’ll instantly connect you with a stranger. You can enter interests to improve matches, or keep it fully random."
            },
            {
              q: "Can I play games during a random video chat?",
              a: "Yes! You can challenge your match to quick quizzes or fun laugh challenges to keep the vibe light."
            },
            {
              q: "Do I need to sign up?",
              a: "No. Guest login lets you join instantly. You can also use Google or Facebook if you want a saved profile."
            },
            {
              q: "Is it free?",
              a: "Yes. Talkvee is 100% free, with no hidden costs or subscriptions."
            },
            {
              q: "Is my video or audio recorded?",
              a: "No. Your streams are peer-to-peer and vanish once the chat ends."
            },
            {
              q: "Can I use Talkvee on my phone?",
              a: "Yes. Talkvee runs in your mobile browser and can also be installed as a PWA for a native-like app experience."
            },
          ]}
        />
      </div>
    </>
  );
}